import { FC, ReactNode } from 'react';
import { Heading } from '@kpa/kul';
import XhtmlText from '../XhtmlText';
import { ContentResponse } from '../types/shared';
import { SidfotblockResponse } from '../types/blocks';

interface ISidfotblock {
  contentResponse: ContentResponse;
}

const Sidfotblock: FC<ISidfotblock> = ({ contentResponse }): ReactNode => {
  const sidfotblockResponse = contentResponse.content as SidfotblockResponse;

  return (
    <>
      {sidfotblockResponse.rubrik && <Heading headingLevel={1} headingLevelStyle={3}>{sidfotblockResponse.rubrik}</Heading>}
      {sidfotblockResponse.xhtmlTexten && <XhtmlText xhtmlResponse={sidfotblockResponse.xhtmlTexten} />}
    </>
  );
};

export default Sidfotblock;
